import { Action } from './index';
import { TitleActionType, PlayerActionType, AppActionType, EditPlayerDataActionType } from '../enums';

export interface PlayerState {
    readonly player?: Entities.Player;
    readonly playerData?: Entities.PlayerData[];
    readonly latestLeaderboardSeason?: Entities.PlayerSeasonAndSeason;
    readonly geolocation?: Entities.Geolocation;
    readonly loginInfo?: Entities.LoginInfo;
    readonly wallet?: Record<string, number>;
    readonly firebaseInfo?: Entities.PlayerFirebaseInfo;
    readonly playerGroup?: Entities.PlayerGroup;
    readonly stackables?: Entities.PlayerStackableItem[];
    readonly nonStackables?: Entities.PlayerNonStackableItem[];
    readonly editInfo?: {
        titleDataItems: Entities.TitleDataItem[];
        liveEvents: Entities.LiveEvent[];
        playerData: Entities.PlayerData[];
    };
}

export type PlayerAction = Action<Partial<PlayerState>>;

const initState = (): PlayerState => ({
});

const reducer = (
    state: PlayerState = initState(),
    action: PlayerAction,
): PlayerState => {
    switch (action.type) {
        case AppActionType.Init:
            return { ...state, ...action.payload };
        case PlayerActionType.UpdatePlayers:
            return { ...state, ...action.payload };
        case PlayerActionType.UpdatePlayerData:
            return { ...state, ...action.payload };
        case PlayerActionType.GetCompensations:
            return { ...state, ...action.payload };
        case EditPlayerDataActionType.Update:
            return { ...state, ...action.payload };
        case TitleActionType.Reset:
            return { ...state };
    }
    return state;
};
export default reducer;
